export default "__VITE_ASSET__c5Rr6qWi__"